import { DAYS_IN_WEEK } from '@/constants/global';
import { DateTime } from 'luxon';

export const widgetWeeklySummary = {
    namespaced: true,

    state: {
        loadingWeeklySummary: false,
        agendaItems: [],
        morningMonitoring: [],
        currentWeek: {
            start: DateTime.now().startOf('week'),
            end: DateTime.now().endOf('week')
        }
    },

    getters: {
        agendaItems(state) {
            return state.agendaItems;
        },

        currentWeek(state) {
            return state.currentWeek;
        },

        currentWeekNumber(state) {
            return state.currentWeek.start.weekNumber;
        },

        loadingWeeklySummary(state) {
            return state.loadingWeeklySummary;
        },

        morningMonitoring(state) {
            return state.morningMonitoring;
        }
    },

    mutations: {
        resetState(state) {
            state.agendaItems = [];
        },

        resetCurrentWeek(state) {
            state.currentWeek = {
                start: DateTime.now().startOf('week'),
                end: DateTime.now().endOf('week')
            };
        },

        updateCurrentWeek(state, data) {
            state.currentWeek.start = data.start;
            state.currentWeek.end = data.end;
        },

        addAgendaItems(state, data) {
            state.agendaItems = [];

            for (let i = 0; i < DAYS_IN_WEEK; i++) {
                state.agendaItems.push({
                    day: state.currentWeek.start.plus({ days: i }),
                    items: []
                });
            }

            data.forEach(item => {
                const startDayOrdinal = DateTime.fromSQL(item.start_date).weekday;
                const endDayOrdinal = DateTime.fromSQL(item.end_date).weekday;
                // in case of multi day session multiply session in each day
                for (let dayIndex = startDayOrdinal; dayIndex <= endDayOrdinal; dayIndex++) {
                    state.agendaItems[dayIndex - 1].items.push(item);
                }
            });
        },

        setMorningMonitoring(state, morningMonitoring) {
            state.morningMonitoring = morningMonitoring;
        },

        setLoading(state, data) {
            state.loadingWeeklySummary = data;
        }
    },

    actions: {
        getMorningMonitoringDateRange(context, data) {
            return context
                .dispatch(
                    'post',
                    {
                        url: `${api}morning-monitoring-date-range`,
                        data: {
                            date_from: context.rootGetters['widgetWeeklySummary/currentWeek'].start.toISODate(),
                            date_to: context.rootGetters['widgetWeeklySummary/currentWeek'].end.toISODate(),
                            athlete_ids: data.athleteIds
                        }
                    },
                    { root: true }
                )
                .then(response => {
                    context.commit('setMorningMonitoring', response.data);
                })
                .catch(error => {
                    context.dispatch('notifyError', error, { root: true });
                });
        },

        getAgenda(context, data) {
            context.commit('setLoading', true);
            const fields = [
                'id',
                'heart_rate_intensities',
                'name',
                'session_id',
                'sport',
                'start_date',
                'end_date',
                'session_id',
                'all_day_event',
                'pieces_count',
                'planned_time',
                'planned_distance',
                'attendance_limit'
            ].join('|');
            return context
                .dispatch(
                    'post',
                    {
                        url: `${api}agenda?fields=${fields}`,
                        data: {
                            start_date: context.rootGetters['widgetWeeklySummary/currentWeek'].start.toISODate(),
                            end_date: context.rootGetters['widgetWeeklySummary/currentWeek'].end.toISODate(),
                            athlete_ids: data.athleteIds,
                            one_user_id: data.athleteIds.length ? data.athleteIds[0] : null,
                            display: data.display,
                            include: [
                                'club:fields(id|name|picture)',
                                'one_user_results:fields(id|sport|has_results)',
                                'one_user_results.sport.pieces:fields(id|session_structure_id)',
                                'one_user_results.sport.pieces.segments:fields(id)',
                                'one_user_session_files:fields(total_time|hr_times_in_zones|average_heart_rate)',
                                'participants:fields(user_id|user_role_id)',
                                'session:fields(id)',
                                'session.structure:fields(id)',
                                'session.structure.pieces:fields(id)',
                                'statistics',
                                'user_actions'
                            ].join(',')
                        }
                    },
                    { root: true }
                )
                .then(response => {
                    context.commit('addAgendaItems', response.data.data);
                })
                .catch(error => {
                    context.dispatch('notifyError', error, { root: true });
                })
                .finally(() => {
                    context.commit('setLoading', false);
                });
        }
    }
};

export default widgetWeeklySummary;
